/* AUDIORALIS — cancel an order (/pages/cancel-order)
 *
 * Two jobs:
 *   1. Prefill the order-number field from ?order=1024 so the order emails
 *      can deep-link here. Runs in both modes.
 *   2. If the section has an endpoint configured (data-endpoint), take over
 *      the submit and POST JSON { order_number, email, name } to the cancel
 *      service instead of letting the form post as a Shopify contact form.
 *      Reply contract (same vocabulary as arachne.audio's service):
 *        { ok: true, order: "#1024" }
 *        { ok: false, reason: "not_found" | "email_mismatch" | "fulfilled" |
 *                            "already_cancelled" | "production_started" |
 *                            "rate_limited" | "error", order?: "#1024" }
 *      not_found / email_mismatch / rate_limited / error keep the form up with
 *      an inline alert; the other three replace it with an outcome panel.
 *
 * With no endpoint (or no fetch, or a script error) the form is a plain
 * contact form and posts to Shopify — the script is an upgrade, never a
 * dependency. All copy comes from the section's settings via the JSON block
 * #aud-cancel-msgs; nothing is hard-coded here but the fallbacks.
 */
(function () {
  'use strict';

  var root = document.getElementById('aud-cancel');
  if (!root) return;

  var orderEl = document.getElementById('CancelForm-order');

  // 1. ?order=1024 → "#1024"
  try {
    var q = new URLSearchParams(window.location.search).get('order');
    if (q && orderEl && !orderEl.value) {
      var digits = q.replace(/[^0-9]/g, '');
      if (digits) orderEl.value = '#' + digits;
    }
  } catch (e) { /* no URLSearchParams — fine, nothing to prefill */ }

  // 2. endpoint mode
  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var form = root.querySelector('form.aud-cancel__form');
  if (!endpoint || !form || typeof window.fetch !== 'function') return;

  var emailEl = document.getElementById('CancelForm-email');
  var nameEl = document.getElementById('CancelForm-name');
  var alertEl = form.querySelector('.aud-cancel__alert');
  var btn = form.querySelector('.aud-cancel__foot .aud-btn');
  if (!orderEl || !emailEl || !nameEl || !btn) return;

  var msgs = {};
  try {
    msgs = JSON.parse(document.getElementById('aud-cancel-msgs').textContent) || {};
  } catch (e) { msgs = {}; }

  var shopEmail = msgs.email || 'hello@audioralis.com';
  var FALLBACK = {
    ok_title: 'Cancelled.',
    ok_body: 'Order {order} is cancelled and the refund is on its way back to the payment method you used.',
    fulfilled_title: 'Already on its way.',
    fulfilled_body: 'Order {order} has already shipped and can’t be stopped. We’ll email you the return steps.',
    already_cancelled_title: 'Already cancelled.',
    already_cancelled_body: 'Order {order} was already cancelled.',
    production_started_title: 'This one can’t be stopped.',
    production_started_body: 'Order {order} is made to your specification and the run has been placed.',
    not_found: 'We can’t find an order with that number.',
    email_mismatch: 'That email address doesn’t match the one on the order.',
    rate_limited: 'Too many tries in a row. Wait a few minutes and try again.',
    error: 'Something went wrong on our side. Write to us with the order number and we’ll cancel it by hand.',
    required: 'All three fields are needed to match the order.'
  };
  function msg(key) {
    var v = msgs[key];
    return (typeof v === 'string' && v.trim()) ? v : (FALLBACK[key] || '');
  }

  var idleLabel = btn.getAttribute('data-label') || btn.textContent.trim();
  var busyLabel = btn.getAttribute('data-busy') || 'One moment…';

  function setBusy(on) {
    form.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.disabled = !!on;
    // keep the arrow span; swap only the text node
    var label = on ? busyLabel : idleLabel;
    var arrow = btn.querySelector('.aud-arrow');
    btn.textContent = label + ' ';
    if (arrow) btn.appendChild(arrow);
  }

  function mailLink() {
    var a = document.createElement('a');
    a.href = 'mailto:' + shopEmail;
    a.textContent = shopEmail;
    return a;
  }

  function showAlert(text) {
    if (!alertEl) return;
    alertEl.innerHTML = '';
    var p = document.createElement('p');
    p.appendChild(document.createTextNode(text + ' '));
    p.appendChild(mailLink());
    alertEl.appendChild(p);
    alertEl.hidden = false;
    try { alertEl.focus(); } catch (e) { /* older browsers */ }
  }

  function hideAlert() {
    if (!alertEl) return;
    alertEl.hidden = true;
    alertEl.innerHTML = '';
  }

  // "{order}" → <span class="aud-cancel__order">#1024</span>, as DOM not HTML
  function fillOrder(el, text, orderName) {
    var parts = String(text).split('{order}');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i]) el.appendChild(document.createTextNode(parts[i]));
      if (i < parts.length - 1) {
        var s = document.createElement('span');
        s.className = 'aud-cancel__order';
        s.textContent = orderName;
        el.appendChild(s);
      }
    }
  }

  function showOutcome(kind, orderName) {
    // kind: 'ok' | 'fulfilled' | 'already_cancelled' | 'production_started'
    var ok = kind === 'ok';
    var panel = document.createElement('div');
    panel.className = 'aud-cform__done' + (ok ? '' : ' aud-cform__done--info');
    panel.setAttribute('tabindex', '-1');
    panel.setAttribute('role', 'status');

    var mark = document.createElement('span');
    mark.className = 'aud-cform__done-mark';
    mark.setAttribute('aria-hidden', 'true');
    mark.textContent = ok ? '✓' : 'i';
    panel.appendChild(mark);

    var h = document.createElement('h2');
    fillOrder(h, msg(kind + '_title'), orderName);
    panel.appendChild(h);

    var p = document.createElement('p');
    fillOrder(p, msg(kind + '_body'), orderName);
    if (!ok) {
      p.appendChild(document.createTextNode(' '));
      p.appendChild(mailLink());
    }
    panel.appendChild(p);

    var back = document.createElement('a');
    back.className = 'aud-cancel__done-link';
    back.href = '/';
    back.textContent = 'Back to the shop →';
    panel.appendChild(back);

    form.innerHTML = '';
    form.appendChild(panel);
    try { panel.focus(); } catch (e) { /* fine */ }
  }

  function normaliseOrder(v) {
    var digits = String(v || '').replace(/[^0-9]/g, '');
    return digits ? '#' + digits : '';
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    hideAlert();

    var order = normaliseOrder(orderEl.value);
    var email = (emailEl.value || '').trim().toLowerCase();
    var name = (nameEl.value || '').trim();

    if (!order) { showAlert(msg('required')); orderEl.focus(); return; }
    if (!email) { showAlert(msg('required')); emailEl.focus(); return; }
    if (!name) { showAlert(msg('required')); nameEl.focus(); return; }

    setBusy(true);

    var controller = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 20000) : null;

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ order_number: order, email: email, name: name, source: 'audioralis.com/pages/cancel-order' }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) { return r.json().catch(function () { return { ok: false, reason: 'error' }; }); })
      .then(function (data) {
        if (timer) clearTimeout(timer);
        data = data || {};
        var orderName = data.order || order;
        if (data.ok) { showOutcome('ok', orderName); return; }
        var reason = data.reason || 'error';
        if (reason === 'fulfilled' || reason === 'already_cancelled' || reason === 'production_started') {
          showOutcome(reason, orderName);
          return;
        }
        setBusy(false);
        showAlert(msg(reason === 'not_found' || reason === 'email_mismatch' || reason === 'rate_limited' ? reason : 'error'));
        if (reason === 'not_found') orderEl.focus();
        else if (reason === 'email_mismatch') emailEl.focus();
      })
      .catch(function () {
        if (timer) clearTimeout(timer);
        setBusy(false);
        showAlert(msg('error'));
      });
  });
})();
